import { Injectable, Injector } from '@angular/core';
import { ListService } from '@shared/models/list-service.model';
import { Observable } from 'rxjs/Rx';
import { Appointments2Service } from '../../../appointments/services/appointments2.service';
import { Utilities } from '@shared/utilities/utilities.model';
import { SelectCommoditiesService } from '@shared/service/select-commodities.service';
import { AuthorityBaseService } from './authority-base.service';
import { PermissionService } from '@shared/service/permission.service';
import { RequestOptions } from '@angular/http';
import { DossierWorkingListModel } from '@authority/authority-shared/models/dossier-working-list.model';
import { DossierWorkingFilterModel } from '@authority/authority-shared/models/dossier-working-filter.model';
import { GroupChanneling } from '../models/group-channeling.model';
import { WorkingModel } from '../models/working.model';
// import { AuthorityUtilities } from '../utilities/authority-utilities';


@Injectable()
export class DossierWorkingService extends AuthorityBaseService implements ListService {
	
	path_v1: string = '';

	constructor(
		protected injector: Injector,
		private selectCommoditiesService: SelectCommoditiesService,
		public appointmentService: Appointments2Service,
		public permissionsService: PermissionService,
	) {
		super(injector);
		this.path_v1 = this.environment.AUTHORITY;
	}
	
	getCommodities(): string[] {
		return this.selectCommoditiesService.getCurrentCommodities().map(commodity => commodity.id);
	}
	
	getBaseURL(x?: boolean | WorkingModel, v: string = 'v1'): string {

		// const v = Utilities.nullish(version, 'v1');
		const apiAuthority = this.environment.api.authority;

		if (Utilities.isEmpty(x) || x === false) {
			return apiAuthority[v];
		}

		if (x == true) {
			return apiAuthority.historical[v];
		}
		
		if (x instanceof WorkingModel) {
			return x && x.isArchived() ? apiAuthority.historical[v] : apiAuthority[v];
		}
		
		return apiAuthority[v];
	}

	handleRequest<T>(type: {new(...args : any[]): T ;}): Function {

		const ctx = this;

		return function(url: string, http_options?: any): Observable<T>  {
			
			const options: RequestOptions = Utilities.nullish(http_options, Utilities.setOptionsWithNemoCommodityID(ctx.getCommodities()));
	
			return new Observable<T>(
				observer => {
					ctx.httpAuthService.get(url, ctx.redirectUrl, options).subscribe(
						res => {
							const content = res.json();
							if (res.status === 200) {
								try {
									observer.next(new type(content));
								} catch (err) {
									console.error(err);
									observer.error(err);
								}
							} else if ([404, 405, 500].includes(res.status)) {
								console.error(content);
								observer.next(content);
							} else {
								observer.next(null);
							}
						},
						err => {
							console.error(err);
							observer.error(err);
						}
					);
				}
			);
		}
	}

	getList(filter: DossierWorkingFilterModel, params?: any): Observable<DossierWorkingListModel> {
		
		let url: string = `${this.path_v1}/workings`;
		if (filter) {
			url = url + filter.getFilterUrl();
		}

		// const commodities: string[] = this.selectCommoditiesService.getIDCommodities();
		// const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(commodities);
		const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		return new Observable<DossierWorkingListModel>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
					res => {
						const content = res.json();
						if (!res.ok) {
							observer.error(content);
							return;	
						}
						try {
							observer.next(new DossierWorkingListModel(content));
						} catch (err) {
							console.error(err);
							observer.error(err);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
	}
	
	/**
	 * Archiviazione e performance
	 * recupera le pratiche archiviate
	 * 
	 * @param {DossierWorkingFilterModel} filter
	 * @param {any} params?
	 * @returns {Observable<DossierWorkingListModel>}
	 */
	getListArchived(filter: DossierWorkingFilterModel, params?: any): Observable<DossierWorkingListModel> {

		// let url: string = this.environment.api.authority.historical.v1 + '/workings';
		let url: string = this.getBaseURL(true) + '/workings';

		if (filter) {
			// TODO
			// forse va fatta una forzatura sullo stato che dev'essere CLOSED
			url = url + filter.getFilterUrl();
		}
		return this.handleRequest<DossierWorkingListModel>(DossierWorkingListModel)(url);
	}
	
	getCompanyList(): Observable<any> {
		
		let url: string = `${this.environment.ADMINISTRATION_CHANNELING}/users/companies`;
		// const commodities: string[] = this.selectCommoditiesService.getIDCommodities();
		// const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(commodities);
		const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		return new Observable<any>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
					response => {
						const content = response.json();
						if (!response.ok) {
							observer.error(content);
							return;
						}
						try {
							observer.next(content);
						} catch (err) {
							console.error(err)
							observer.error(err);
						}
					},
					err => {
						console.error(err)
						observer.error(err);
					}
				);
			});
	}
	
	getUserGroupList(): Observable<GroupChanneling[]> {
		
		let url: string = `${this.environment.ADMINISTRATION_CHANNELING}/groups?pageSize=1000`;
		// const commodities: string[] = this.selectCommoditiesService.getIDCommodities();
		// const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(commodities);
		const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(this.getCommodities());
		return new Observable<GroupChanneling[]>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
					response => {
						const items = response.json().items;
						const content = !Utilities.isEmpty(items) ? items.map(x => new GroupChanneling(x)) : [];
						if (!response.ok) {
							observer.error(response);
							return;
						}
						try {
							observer.next(content);
						} catch (err) {
							console.error(err)
							observer.error(err);
						}
					},
					err => {
						console.error(err)
						observer.error(err);
					}
				);
			});
	}

	getSupplementsList(): Observable<any> {
		let url: string = `${this.environment.AUTHORITY}/extras`;
		return new Observable<any>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl).subscribe(
					response => {
						const content = response.json();
						if (!response.ok) {
							observer.error(content);
							return;
						}
						try {
							observer.next(content.extra_entities);
						} catch (err) {
							console.error(err)
							observer.error(err);
						}
					},
					err => {
						console.error(err)
						observer.error(err);
					}
				);
			});
	}
	patchSupplementsList(supplementList:any): Observable<any> {
		let url: string = `${this.environment.AUTHORITY}/extras`;
		let body: any = {extra_entities: supplementList};
		return new Observable<any>(
			observer => {
				this.httpAuthService.patch(url, body, this.redirectUrl).subscribe(
					response => {
						const content = response;
						if (!response.ok) {
							observer.error(content);
							return;
						}
						try {
							observer.next(content);
						} catch (err) {
							console.error(err)
							observer.error(err);
						}
					},
					err => {
						console.error(err)
						observer.error(err);
					}
				);
			});
	}
	getCenterRulesByCommodityId(working: WorkingModel): Observable<any> {
		// let url: string = `${this.environment.AUTHORITY_V2}/commodities/${commodityId}/vehicle_rules`;
		let url: string = `${this.getBaseURL(working.isArchived(), 'v2')}/commodities/${working.commodity_id}/vehicle_rules`;

		return new Observable<any>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl).subscribe(
					response => {
						const content = response.json();
						if (!response.ok) {
							observer.error(content);
							return;
						}
						try {
							observer.next(content.vehicle_rules);
						} catch (err) {
							console.error(err)
							observer.error(err);
						}
					},
					err => {
						console.error(err)
						observer.error(err);
					}
				);
			});
	}
}
